
export const CLIENTS_API_REGISTER_CLIENT_USER = 'registerClientUser'

export type RegisterClientUserArgs = { clientId: string, username: string }
export type RegisterClientUserResponse = string // Timestamp
